import "emoji-mart/css/emoji-mart.css";

import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Row,
  Space,
  Spin,
  Tabs,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Emoji from "react-emoji-render";
import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";

import {
  getActiveUsers,
  getAllUsersPaginatedFrom,
  getAtRiskUsers,
  getAtRiskUsersTwoWeeks,
  getInactiveUsers,
  getInitialUsers,
  getNewUsers,
} from "../../lib/queries";
import { getSupaClient } from "../../lib/supabase";
import {
  setActiveUsersData,
  setAllUsersData,
  setAtRiskUsersData,
  setInactiveUsersData,
  setNewUsersData,
  setTeamTagsData,
  setUserViewsData,
} from "../../redux/actions";
import NewSearch from "../NewSearch/NewSearch";
import SendDM from "../SendDM/SendDM";
import BulkEdit from "./BulkEdit";
import CreateNewView from "./CreateNewView";
import CustomFilterTab from "./CustomFilterTab";
import MemberDetail from "./MemberDetail";
import UserTable from "./UserTable";

const { RangePicker } = DatePicker;

const options = {
  includeScore: true,
  threshold: 0.3,
  keys: [
    "name",
    "directory_bio",
    "directory_industry_experience.name",
    "directory_looking",
    "directory_interest_free_text",
    "directory_skills.name",
    "directory_location",
    "directory_title",
  ],
};

const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
const dateFormat = "YYYY-MM-DD";

const { TabPane } = Tabs;

function tabCallback(key) {
  console.log(key);
}

const SlackMembers = () => {
  const dispatch = useDispatch();
  const supabase = getSupaClient();
  const [startTime, setStartTime] = useState(
    moment().subtract(7, "d").format(defaultTimeFormat)
  );
  const [endTime, setEndTime] = useState(moment().format(defaultTimeFormat));
  const newUsers = useSelector((state) => state.users.new_users);
  const activeUsers = useSelector((state) => state.users.active_users);
  const atRiskUsers = useSelector((state) => state.users.at_risk_users);
  const inactiveUsers = useSelector((state) => state.users.inactive_users);
  // const [detailUser, setDetailUser] = useState({ userInfo: {} });
  const allUsers = useSelector((state) => state.users.all_users);
  const teamTags = useSelector((state) => state.teamTags.team_tags);
  const userViews = useSelector((state) => state.users.user_views);

  const [selectedMember, setSelectedMember] = useState();
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedMembersId, setSelectedMembersId] = useState([]);
  const [isBulkEditModalVisible, setIsBulkEditModalVisible] = useState(false);
  const [isMassDmVisible, setIsMassDmVisible] = useState(false);
  const [userDetailTime, setUserDetailTime] = useState({
    startTime,
    endTime,
  });
  const [fuse, setFuse] = useState([]);
  const [datePickerText, setDatePickerText] = useState("Past 7 days");
  const [loadingAllUsers, setLoadingAllUsers] = useState(true);
  const [loadingActiveUsers, setLoadingActiveUsers] = useState(true);
  const [loadingAtRiskUsers, setLoadingAtRiskUsers] = useState(true);
  const [loadingInactiveUsers, setLoadingInactiveUsers] = useState(true);
  const [loadingNewUsers, setLoadingNewUsers] = useState(true);
  const [riskData, setRiskData] = useState({
    active_period_start: 90,
    inactive_period_start: 30,
  });

  const teamId = localStorage.getItem("team-id");

  // console.log("allUsers:", allUsers);

  // const disabledDate = (current) => {
  //   // Can not select days before today and today
  //   return current && current > moment().endOf("day");
  // };

  const loadTeamTags = async () => {
    const { data, error } = await supabase
      .from("tags")
      .select("id, name, color")
      .eq("team", teamId);
    if (data) {
      // setTeamTags(data);
      dispatch(setTeamTagsData(data));
    }
    if (error) {
      console.log("Error", error);
    }
  };

  const loadAllUsers = async () => {
    setLoadingAllUsers(true);
    const { initialUsers, cursor } = await getInitialUsers(teamId);
    dispatch(setAllUsersData(initialUsers));
    // setLoading(false);
    if (cursor > 0) {
      console.log("in pagination");
      const allUsersPaginated = await getAllUsersPaginatedFrom(teamId, cursor);
      dispatch(setAllUsersData(initialUsers.concat(allUsersPaginated)));
    }
    setLoadingAllUsers(false);
  };

  const loadActiveUsers = async (start, end) => {
    setLoadingActiveUsers(true);
    const data = await getActiveUsers(start, end, teamId);
    if (data) {
      const active = data.map((result) => {
        result.slack_id = result.user_id;
        result.name = result.user_name;
        result.key = result.user_id;
        return result;
      });
      dispatch(setActiveUsersData(active));
    }
    setLoadingActiveUsers(false);
    return data;
  };

  /*
   * Purpose: Get the inactive Slack users for a given team and time period.
   * Params:
      start: start of time period
      end: end of time period
  */
  const loadInactiveUsers = async (start, end) => {
    setLoadingInactiveUsers(true);
    const data = await getInactiveUsers(start, end, teamId);
    if (data) {
      const inactive = data.map((result) => {
        result.slack_id = result.user_id;
        result.name = result.user_name;
        result.key = result.user_id;
        return result;
      });
      dispatch(setInactiveUsersData(inactive));
    }
    setLoadingInactiveUsers(false);
    return data;
  };

  const loadNewUsers = async (start, end) => {
    setLoadingNewUsers(true);
    const data = await getNewUsers(start, end, teamId);
    if (data) {
      const newMembers = await data.map((result) => {
        result.dateJoined = moment(result.date_joined).format("MM/DD/YYYY");
        result.slack_id = result.user_id;
        result.name = result.user_name;
        result.key = result.user_id;
        return result;
      });
      dispatch(setNewUsersData(newMembers));
      setLoadingNewUsers(false);
      return newMembers;
    }
    setLoadingNewUsers(false);
    return data;
  };

  /**
   * Load data from custom_at_risk_users table
   */
  const loadAtRiskDef = async () => {
    const { data, error } = await supabase
      .from("custom_at_risk_users")
      .select("*")
      .eq("team", teamId);
    if (data.length > 0) {
      setRiskData({
        active_period_start: data[0].active_period_start,
        inactive_period_start: data[0].inactive_period_start,
      });
    }
    if (error) {
      console.log("Error", error);
      return null;
    }
    return data[0];
  };

  const loadAtRiskUsers = async (start, end) => {
    setLoadingAtRiskUsers(true);
    let data = [];

    const riskDef = await loadAtRiskDef();
    data = await getAtRiskUsers(teamId, riskDef);

    if (data) {
      const atRisk = data.map((result) => {
        result.lastPostedDate = new Date(
          parseInt(result.last_posted, 10) * 1000
        ).toLocaleDateString();
        result.slack_id = result.user_id;
        result.name = result.user_name;
        result.key = result.user_id;
        return result;
      });
      dispatch(setAtRiskUsersData(atRisk));
      setLoadingAtRiskUsers(false);
      return atRisk;
    }
    setLoadingAtRiskUsers(false);

    return data;
  };

  const loadViews = async () => {
    const { data, error } = await supabase
      .from("user_views")
      .select("id, name")
      .eq("team", teamId)
      .order("id", { ascending: true });
    if (data) {
      dispatch(setUserViewsData(data));
    }
    if (error) {
      console.log("error", error);
    }
  };

  const loadPageData = async (start, end) => {
    if (allUsers.length !== 0) {
      setLoadingAllUsers(false);
      setLoadingActiveUsers(false);
      setLoadingAtRiskUsers(false);
      setLoadingInactiveUsers(false);
      setLoadingNewUsers(false);
    }
    if (userViews.length === 0) {
      await loadViews();
    }
    if (allUsers.length === 0) {
      loadAllUsers();
    }
    if (teamTags.length === 0) {
      loadTeamTags();
    }
    if (activeUsers.length === 0) {
      loadActiveUsers(start, end);
    }
    if (newUsers.length === 0) {
      loadNewUsers(start, end);
    }
    if (atRiskUsers.length === 0) {
      loadAtRiskUsers();
    }
    if (inactiveUsers.length === 0) {
      loadInactiveUsers(start, end);
    }
  };

  const loadUpdatedActiveUsers = async (start, end) => {
    await loadActiveUsers(start, end);
  };

  const loadUpdatedInactiveUsers = async (start, end) => {
    await loadInactiveUsers(start, end);
  };

  const loadUpdatedNewUsers = async (start, end) => {
    await loadNewUsers(start, end);
  };

  const loadUpdatedAtRiskUsers = async (start, end) => {
    await loadAtRiskUsers();
  };

  const reloadUsers = async (start, end) => {
    loadActiveUsers(start, end);
    loadInactiveUsers(start, end);
    loadNewUsers(start, end);
    loadAtRiskUsers();
    loadAllUsers();
  };

  useEffect(() => {
    loadPageData(startTime, endTime);
    document.title = "Members | Dots";
  }, []);

  const dateChanged = async (newStartTime, newEndTime) => {
    setStartTime(newStartTime);
    setEndTime(newEndTime);
    await loadPageData(
      newStartTime.format(defaultTimeFormat),
      newEndTime.format(defaultTimeFormat)
    );
  };

  function handleMenuClick(e) {
    // eslint-disable-next-line no-empty
    // past 7 days
    if (e.key === "2") {
      if (datePickerText !== "Past 7 days") {
        dateChanged(moment().subtract(7, "day"), moment());
        setDatePickerText("Past 7 days");
      }
    }
    // past 30 days
    else if (e.key === "3") {
      if (datePickerText !== "Past 30 days") {
        dateChanged(moment().subtract(30, "day"), moment());
        setDatePickerText("Past 30 days");
      }
    }
    // custom
    else if (e.key === "4") {
      setDatePickerText("Select range");
    }
  }
  // data changed
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUserModalVisibile, setIsUserModalVisibile] = useState(false);
  // const [isUserDetailLoading, setIsUserDetailLoading] = useState(true);

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  const handleUserCancel = () => {
    setIsUserModalVisibile(false);
    // setDetailUser({ userInfo: {} });
    // setSelectedMember(null);
  };

  const showUserModal = async (record) => {
    setIsUserModalVisibile(true);
    // setIsUserDetailLoading(true);
    window.analytics.track("User modal opened");
    setSelectedMember(record);
  };

  const showAtRiskModal = async (record) => {
    setIsUserModalVisibile(true);
    setSelectedMember(record);
    window.analytics.track("At risk modal opened");
    setUserDetailTime({
      startTime: moment().subtract(91, "d").format(defaultTimeFormat),
      endTime: moment().format(defaultTimeFormat),
    });
  };

  const teamTagsChange = (record) => {
    // setTeamTags(
    //   teamTags.concat({ id: record.id, name: record.name, color: record.color })
    // );
    dispatch(
      setTeamTagsData(
        teamTags.concat({
          id: record.id,
          name: record.name,
          color: record.color,
        })
      )
    );
  };

  const memberTagsChange = () => {
    reloadUsers(startTime, endTime);
  };

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            // eslint-disable-next-line no-unused-vars
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ fontSize: 20, color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) => {
      return record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "";
    },
    onFilterDropdownVisibleChange: () => {},
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const allUserscolumns = [
    {
      title: "Email",
      dataIndex: "tags",
      key: "tags",
      ...getColumnSearchProps("email"),
      render: (text, record) => (
        <p>{record.email ? record.email : "No email found"}</p>
      ),
      width: "40%",
    },
    // opposite
    {
      title: "Accepted invite",
      dataIndex: "is_invited",
      key: "is_invited",
      filters: [
        { text: "Yes", value: null },
        { text: "No", value: true },
      ],
      onFilter: (value, record) => {
        // console.log(value, record);
        return record.is_invited === value;
      },
      render: (text, record) => <p>{record.is_invited ? "No" : "Yes"}</p>,
      width: "40%",
    },
  ];

  const activeUserscolumns = [
    {
      title: "# convos started",
      dataIndex: "parent_count",
      key: "parent_count",
      sorter: (a, b) => {
        return a.parent_count - b.parent_count;
      },
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "# replies sent",
      dataIndex: "thread_count",
      key: "thread_count",
      sorter: (a, b) => {
        return a.thread_count - b.thread_count;
      },
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Total messages sent",
      dataIndex: "total_messages_count",
      key: "total_messages_count",
      sorter: (a, b) => {
        return a.total_messages_count - b.total_messages_count;
      },
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "# reactions added",
      dataIndex: "reaction_count",
      sorter: (a, b) => {
        return a.reaction_count - b.reaction_count;
      },
      sortDirections: ["descend", "ascend"],
    },
  ];

  const newUsersColumns = [
    {
      title: "Messages sent",
      dataIndex: "message_count",
      sorter: (a, b) => {
        return a.message_count - b.message_count;
      },
      filters: [
        { text: "1", value: 1 },
        { text: "0", value: 0 },
      ],
      onFilter: (value, record) => {
        console.log(value, record);
        return record.message_count === value;
      },
    },
    {
      title: "Date joined",
      dataIndex: "dateJoined",
      sorter: (a, b) => {
        if (a.date_joined > b.date_joined) return 1;
        if (b.date_joined > a.date_joined) return -1;
        return 0;
      },
    },
  ];

  const atRiskUsersColumns = [
    {
      title: "# of Messages (last 90 days)",
      dataIndex: "last_month_count",
      sorter: (a, b) => {
        return a.last_month_count - b.last_month_count;
      },
    },
    {
      title: "Date last posted",
      dataIndex: "lastPostedDate",
      sorter: (a, b) => {
        if (a.last_posted > b.last_posted) return 1;
        if (b.last_posted > a.last_posted) return -1;
        return 0;
      },
    },
  ];

  const getAtRiskColumns = () => {
    return atRiskUsersColumns;
  };

  const getAtRiskDescription = () => {
    return `At risk members posted at least 5 messages in the last ${
      riskData ? riskData?.active_period_start : "90"
    }
    days, but none in the last ${
      riskData ? riskData?.inactive_period_start : "30"
    } days.`;
  };

  const bulkEditOk = () => {
    loadAllUsers();
    message.success("Tags added");
    setIsBulkEditModalVisible(false);
  };

  const bulkEditCancel = () => {
    setIsBulkEditModalVisible(false);
  };

  const closeDmModal = () => {
    // console.log(ids, selectedMembers);
    setIsMassDmVisible(false);
  };

  const openSearchedMemberProfile = (id) => {
    const record = allUsers.find((item) => item.slack_id === id);
    console.log("member", record);
    showUserModal({ ...record, user_id: id, user_name: record.name });
  };

  const customTabs = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const view of userViews) {
    customTabs.push(
      <TabPane
        tab={view.name}
        key={`custom-${view.id}`}
        style={{ paddingTop: 20 }}
      >
        <CustomFilterTab
          loadViews={loadViews}
          viewId={view.id}
          startTime={startTime}
          endTime={endTime}
        />
      </TabPane>
    );
  }

  return (
    <div>
      <Row style={{ paddingBottom: 40 }}>
        <Col span={8} />
        <Col span={8}>
          <NewSearch
            placeholder="Search for members"
            items={allUsers}
            handleSelection={openSearchedMemberProfile}
            platform="slack"
          />
        </Col>
        <Col span={8} style={{ textAlign: "end" }} />
      </Row>

      <Tabs defaultActiveKey="1" onChange={tabCallback}>
        <TabPane tab="All members" key="1" style={{ paddingTop: 20 }}>
          <UserTable
            startTime={startTime}
            endTime={endTime}
            setStartTime={setStartTime}
            setEndTime={setEndTime}
            loadPageData={loadAllUsers}
            teamId={teamId}
            hideDateRange
            loading={loadingAllUsers}
            allUsers={allUsers}
            otherColumns={allUserscolumns}
            loadParentData={() => reloadUsers(startTime, endTime)}
            description={
              <div>
                All members. You can change the # viewable at the end of the
                table
              </div>
            }
          />
        </TabPane>
        <TabPane tab="Active" key="2" style={{ paddingTop: 20 }}>
          <UserTable
            startTime={startTime}
            endTime={endTime}
            setStartTime={setStartTime}
            setEndTime={setEndTime}
            loadPageData={loadUpdatedActiveUsers}
            teamId={teamId}
            allUsers={activeUsers}
            loading={loadingActiveUsers}
            otherColumns={activeUserscolumns}
            loadParentData={() => reloadUsers(startTime, endTime)}
            description="Members who are most active (top 100)"
          />
        </TabPane>
        <TabPane tab="At risk" key="3" style={{ padding: 20 }}>
          <UserTable
            atRisk
            riskData={riskData}
            setRiskData={setRiskData}
            startTime={startTime}
            endTime={endTime}
            setStartTime={setStartTime}
            setEndTime={setEndTime}
            loadPageData={loadUpdatedAtRiskUsers}
            teamId={teamId}
            hideDateRange
            allUsers={atRiskUsers}
            loading={loadingAtRiskUsers}
            otherColumns={getAtRiskColumns()}
            loadParentData={() => reloadUsers(startTime, endTime)}
            description={<div>{getAtRiskDescription()}</div>}
          />
        </TabPane>
        <TabPane tab="Inactive" key="4" style={{ paddingTop: 20 }}>
          <UserTable
            startTime={startTime}
            endTime={endTime}
            setStartTime={setStartTime}
            setEndTime={setEndTime}
            loadPageData={loadUpdatedInactiveUsers}
            teamId={teamId}
            allUsers={inactiveUsers}
            loading={loadingInactiveUsers}
            otherColumns={allUserscolumns}
            loadParentData={() => reloadUsers(startTime, endTime)}
            description="Members who haven't posted or reacted in the time period"
          />
        </TabPane>
        <TabPane tab="Recently joined" key="5" style={{ padding: 20 }}>
          <UserTable
            startTime={startTime}
            endTime={endTime}
            setStartTime={setStartTime}
            setEndTime={setEndTime}
            loadPageData={loadUpdatedNewUsers}
            teamId={teamId}
            allUsers={newUsers}
            loading={loadingNewUsers}
            otherColumns={newUsersColumns}
            loadParentData={() => reloadUsers(startTime, endTime)}
            description="Members joined recently (last 100)"
          />
        </TabPane>
        {customTabs}
        <TabPane tab="+ New" key="6" style={{ padding: 20, color: "#363636" }}>
          <CreateNewView onChange={loadViews} />
        </TabPane>
      </Tabs>

      <Modal
        width={1200}
        // title={detailUser.userInfo.user_name}
        title={
          selectedMember
            ? `${selectedMember.user_name}'s activity`
            : "Member activity"
        }
        style={{ top: 40, right: 10, borderRadius: 20 }}
        visible={isUserModalVisibile}
        onCancel={handleUserCancel}
        footer={[
          <Button key="submit" onClick={handleUserCancel}>
            Ok
          </Button>,
        ]}
      >
        <MemberDetail
          slackUser={selectedMember}
          onTeamTagAdded={teamTagsChange}
          onMemberTagAdded={memberTagsChange}
          platform="slack"
        />
      </Modal>
    </div>
  );
};

export default SlackMembers;
